import React from 'react';
import { Container, Col, Row, ListGroup, Button, Form, FormControl, Modal, Badge, InputGroup, ButtonGroup, DropdownButton, Dropdown } from 'react-bootstrap';
import { FaEdit, FaEye, FaEyeSlash, FaPen, FaPlus, FaSearch, FaSortAlphaDown, FaSortAmountDownAlt, FaSortAmountUp, FaStar, FaStarHalfAlt, FaTrash, FaWrench } from 'react-icons/fa';

import { VoteStars } from "./voteStars";

import { IntrashBackend } from './backend';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';


export class AllMoviesPage extends React.Component {
    constructor(props) {
        super(props);
        
        this.allFilteredMovies = null;

        this.state = {
            user: null,
            users: [],
            movies: [],
            movieUserVotes: {},
            userReviewedMovies: [],

            showMovieDetails: null,

            movieUserReviewsMovieId: null,
            movieUserReviews: null,

            showFilters: false,
            filtersSearch: null,
            filtersWatchStatus: "All",
            filtersUserVoteStatus: "All",
            filtersUserReviewStatus: "All",
            filtersSort: "Movie Title",
            filtersSortDesc: false,
            filtersShowVote: "Average Vote",

            showEditMovieModal: false,
            editMovieModalTitle: "",
            editMovieModalSortTitle: "",
            editMovieModalReleaseYear: 1990,
            editMovieModalWatched: false,
            editMovieModalClearAllVotes: false,
            editMovieModalIsNewMovie: false,
            editMovieModalMovieId: null,
            
            showVoteModal: false,
            voteModalMovie: null,
            voteModalVote: 0,

            showWriteReviewModal: false,
            writeReviewModalMovie: null,
            writeReviewModalVote: 0,
            writeReviewModalBrief: "",
            writeReviewModalReview: "",

            showReviewModal: false,
            reviewModalMovie: null,
            reviewModalVote: 0,
            reviewModalBrief: "",
            reviewModalReview: "",
            
            movieToDelete: null,
            showDeleteConfirmationModal: false,
            deleteConfirmationModalUsername: "",

            showErrorModal: false,
            errorModalText: ""
        };
        
        this.refreshData();
    }

    async refreshData() {
        this.allFilteredMovies = null;
        const u = await IntrashBackend.getLoggedInUser();
        const allUsers = await IntrashBackend.getUsers();
        const allMovies = await IntrashBackend.getMovies();
        const allVotes = await IntrashBackend.getMovieUserVotes();
        const allReviewedMovies = await IntrashBackend.getUserReviewedMovies();
        var movieReviews = null;
        if (this.state.movieUserReviewsMovieId !== null) { movieReviews = await IntrashBackend.getMovieUserReviews(this.state.movieUserReviewsMovieId); }
        this.setState({
            user: u,
            users: allUsers,
            movies: allMovies,
            movieUserVotes: allVotes,
            movieUserReviews: movieReviews,
            userReviewedMovies: allReviewedMovies
        });
    }

    async handleVote(movieId, vote) {
        await IntrashBackend.setMovieUserVote(movieId, vote);
        this.refreshData();
    }

    async toggleMovieDetails(e, movieId) {
        // Check if the movie details are already being shown
        if (this.state.showMovieDetails !== null && this.state.showMovieDetails === movieId) {
            // Hide the details
            this.setState({ showMovieDetails: null });
        }
        else {
            // Fetch the movie reviews (if necessary)
            var reviews = this.state.movieUserReviews;
            if (reviews === null || this.state.movieUserReviewsMovieId !== movieId) {
                reviews = await IntrashBackend.getMovieUserReviews(movieId);
            }
            
            // Show the details
            this.setState({ showMovieDetails: movieId, movieUserReviewsMovieId: movieId, movieUserReviews: reviews });
        }
        e.preventDefault();
    }

    movieAverageVote(movieId) {
        if (this.state.movieUserVotes[movieId] === undefined) return null;
        var voteCount = 0;
        var totalVote = 0.0;
        Object.values(this.state.movieUserVotes[movieId]).forEach(v => { totalVote += v; ++voteCount; });
        return voteCount > 0 ? (totalVote / voteCount) : null;
    }

    movieAverageVoteString(movieId) {
        const averageVote = this.movieAverageVote(movieId);
        return averageVote === null ? "-" : (averageVote / 20.0).toFixed(2);
    }

    movieUserVote(movieId, userId) {
        if (this.state.movieUserVotes[movieId] === undefined) return null;
        if (this.state.movieUserVotes[movieId][userId] === undefined) return null;
        return this.state.movieUserVotes[movieId][userId];
    }

    movieUserVoteString(movieId, userId) {
        const vote = this.movieUserVote(movieId, userId);
        return vote === null ? "-" : (vote / 20.0);
    }

    userHasReviewedMovie(movieId) {
        return this.state.userReviewedMovies.includes(movieId);
    }

    async startAddMovie(e) {
        try {
            this.setState({
                showEditMovieModal: true,
                editMovieModalTitle: "",
                editMovieModalSortTitle: "",
                editMovieModalReleaseYear: 1990,
                editMovieModalWatched: false,
                editMovieModalIsNewMovie: true
            });
        }
        catch (exc) {
            this.setState({
                showEditMovieModal: false,
                showErrorModal: true,
                errorModalText: "An error occurred: " + exc
            });
        }
        e.preventDefault();
    }

    async editMovie(e, movie) {
        this.setState({
            showEditMovieModal: true,
            editMovieModalTitle: movie.title,
            editMovieModalSortTitle: movie.sortTitle || "",
            editMovieModalReleaseYear: movie.releaseYear,
            editMovieModalWatched: movie.watched,
            editMovieModalClearAllVotes: false,
            editMovieModalIsNewMovie: false,
            editMovieModalMovieId: movie.id
        });
        e.preventDefault();
    }

    async confirmEditMovie(e) {
        try {
            if (this.state.editMovieModalIsNewMovie) {
                await IntrashBackend.addMovie(
                    this.state.editMovieModalTitle, 
                    this.state.editMovieModalSortTitle,
                    this.state.editMovieModalReleaseYear,
                    this.state.editMovieModalWatched
                );
            }
            else {
                await IntrashBackend.editMovie(
                    this.state.editMovieModalMovieId,
                    this.state.editMovieModalTitle,
                    this.state.editMovieModalSortTitle,
                    this.state.editMovieModalReleaseYear,
                    this.state.editMovieModalWatched,
                    this.state.editMovieModalClearAllVotes
                );
            }
            this.setState({ showEditMovieModal: false });
            this.refreshData();
        }
        catch (exc) {
            this.setState({ showEditMovieModal: false, showErrorModal: true, errorModalText: "An error occurred: " + exc });
        }
        e.preventDefault();
    }

    async askDeleteMovie(e, movie) {
        this.setState({ movieToDelete: movie, showDeleteConfirmationModal: true, deleteConfirmationModalMovieTitle: movie.title });
        e.preventDefault();
    }

    async doDeleteMovie(e) {
        try {
            await IntrashBackend.deleteMovie(this.state.movieToDelete.id);
            this.setState({ movieToDelete: null, showDeleteConfirmationModal: false });
            this.refreshData();
        }
        catch (exc) {
            this.setState({ movieToDelete: null, showDeleteConfirmationModal: false, showErrorModal: true, errorModalText: "An error occurred: " + exc });
        }
        e.preventDefault();
    }

    validateEditMovieModal() {
        if (this.state.editMovieModalTitle === null) return false;
        if (this.state.editMovieModalTitle.length < 1) return false;
        if (this.state.editMovieModalReleaseYear === null) return false;
        if (this.state.editMovieModalReleaseYear < 1900) return false;
        return true;
    }

    async startVoting(movie) {
        const vote = this.movieUserVote(movie.id, this.state.user.id) || 0;
        this.setState({
            showVoteModal: true,
            voteModalMovie: movie,
            voteModalVote: vote
        });
    }

    async startWritingReview(movie) {
        const vote = this.movieUserVote(movie.id, this.state.user.id) || 0;
        const previousReview = await IntrashBackend.getMovieUserReviews(movie.id, this.state.user.id);
        const brief = previousReview === null ? "" : previousReview.brief;
        const review = previousReview === null ? "" : previousReview.review;
        this.setState({
            showWriteReviewModal: true,
            writeReviewModalMovie: movie,
            writeReviewModalVote: vote,
            writeReviewModalBrief: brief,
            writeReviewModalReview: review
        });
    }

    validateWriteReviewModal() {
        if (this.state.writeReviewModalBrief === null) return false;
        if (this.state.writeReviewModalBrief.length < 1) return false;
        return true;
    }

    async confirmVote(e) {
        try {
            await IntrashBackend.setMovieUserVote(this.state.voteModalMovie.id, this.state.voteModalVote);
            this.setState({ showVoteModal: false });
            await this.refreshData();
        }
        catch (exc) {
            this.setState({ showVoteModal: false, showErrorModal: true, errorModalText: "An error occurred: " + exc });
        }
        e.preventDefault();
    }

    async confirmWriteReview(e) {
        try {
            await IntrashBackend.setMovieUserVote(this.state.writeReviewModalMovie.id, this.state.writeReviewModalVote);
            await IntrashBackend.setMovieUserReview(this.state.writeReviewModalMovie.id, this.state.writeReviewModalBrief, this.state.writeReviewModalReview);
            this.setState({ showWriteReviewModal: false });
            await this.refreshData();
        }
        catch (exc) {
            this.setState({ showWriteReviewModal: false, showErrorModal: true, errorModalText: "An error occurred: " + exc });
        }
        e.preventDefault();
    }

    async deleteReview(e) {
        try {
            IntrashBackend.deleteMovieUserReview(this.state.writeReviewModalMovie.id);
            this.setState({ showWriteReviewModal: false });
            this.refreshData();
        }
        catch (exc) {
            this.setState({ showWriteReviewModal: false, showErrorModal: true, errorModalText: "An error occurred: " + exc });
        }
        e.preventDefault();
    }

    async showReview(movie, userId) {
        const vote = this.movieUserVote(movie.id, userId);
        if (vote === undefined || vote === null) return;
        const movieReview = await IntrashBackend.getMovieUserReviews(movie.id, userId);
        if (movieReview === undefined || movieReview === null) return;
        const brief = movieReview === null ? "" : movieReview.brief;
        const review = movieReview === null ? "" : movieReview.review;
        this.setState({
            showReviewModal: true,
            reviewModalMovie: movie,
            reviewModalVote: vote,
            reviewModalBrief: brief,
            reviewModalReview: review
        });
    }

    toggleEditMovieModalWatched() {
        const newValue = !this.state.editMovieModalWatched;
        this.setState({ editMovieModalWatched: newValue });
    }

    toggleEditMovieModalClearAllVotes() {
        const newValue = !this.state.editMovieModalClearAllVotes;
        this.setState({ editMovieModalClearAllVotes: newValue });
    }

    mapMovieToListItem = (movie) => {
        const titleFontSize = this.props.renderAsMobile ? "1em" : "1.5em";
        const subtitleFontSize = this.props.renderAsMobile ? "0.75em" : "1em";
        const averageVote = this.movieAverageVote(movie.id);
        const userVote = this.movieUserVote(movie.id, this.state.user.id);
        const shownVote = this.state.filtersShowVote === "My Vote" ? userVote : averageVote;
        const hasVotedMovie = userVote !== null;
        const voteStarsColor = hasVotedMovie ? "gold" : "indianred";
        const hasReviewedMovie = this.userHasReviewedMovie(movie.id);
        const reviewButtonColor = hasReviewedMovie ? "slategray" : "indianred";
        const boundsHorPadding = this.props.renderAsMobile ? "0.25em" : "0.75em";
        const horPadding = this.props.renderAsMobile ? "0.5em" : "1.5em";

        const renderWatchedEye = () => {
            const watchedEyeSize = this.props.renderAsMobile ? "1.25em" : "1.5em";
            if (movie.watched) {
                return (<FaEye size={watchedEyeSize} color="gray"/>);
            }
            else {
                return (<FaEyeSlash size={watchedEyeSize} color="gray"/>);
            }
        };
        const renderReviewButton = () => {
            const reviewButtonSize = this.props.renderAsMobile ? "1.25em" : "1.5em";
            return (
                <FaEdit size={reviewButtonSize} color={reviewButtonColor} cursor="pointer" onClick={() => this.startWritingReview(movie)}/>
            );
        };
        const renderVoteStars = () => {
            if (this.props.renderAsMobile) {
                return (
                    <FaStar size="1.5em" color={voteStarsColor} cursor="pointer" onClick={() => this.startVoting(movie)}/>
                )
            }
            else {
                return (
                    <VoteStars starSize="1.75em" activeColor={voteStarsColor} vote={shownVote} onVote={v => this.handleVote(movie.id, v)}/>
                );
            }
        };
        const mapUserDetailsToMovieDetails = (userDetails) => {
            const u = userDetails.user;
            const hasReview = userDetails.brief !== null && userDetails.brief.trim() !== "";
            const reviewCursor = hasReview ? "pointer" : "default";
            return (
                <ListGroup.Item className="list-group-item border-0" style={{ padding: "0", overflow: "hidden" }} key={u.id} onClick={() => this.showReview(movie, u.id)}>
                    <Row className="align-items-center">
                        <Col xs="auto" style={{ paddingRight: 0, cursor: reviewCursor }}>
                            <VoteStars starSize="1em" vote={userDetails.vote} canEditVote={false}/>
                        </Col>
                        <Col xs="auto" style={{ paddingLeft: 0, paddingRight: 0, cursor: reviewCursor }}>
                            <Badge style={{ fontWeight: "bold", fontSize: "1em" }}>{u.username}</Badge>
                        </Col>
                        <Col style={{ paddingLeft: 0, cursor: reviewCursor }}>
                            <Badge style={{ fontWeight: "normal", fontStyle: "italic", fontSize: "1em" }}>{userDetails.brief}</Badge>
                        </Col>
                    </Row>
                </ListGroup.Item>
            );
        };
        const renderMovieDetails = () => {
            if (this.state.showMovieDetails === movie.id) {
                var userDetails = [];
                const userVotes = this.state.movieUserVotes[movie.id] || {};
                const userReviews = this.state.movieUserReviews || {};
                this.state.users.forEach(u => {
                    const uVote = userVotes[u.id];
                    const uReview = userReviews[u.id];
                    if ((uVote !== undefined) || (uReview !== undefined)) {
                        userDetails.push({
                            user: u,
                            vote: uVote,
                            brief: uReview === undefined ? "" : uReview.brief,
                            review: uReview === undefined ? "" : uReview.review
                        });
                    }
                });
                userDetails.sort((a, b) => b.user.username.toUpperCase() < a.user.username.toUpperCase() ? 1 : -1);
                return (
                    <ListGroup variant="flush" style={{ paddingTop: "1em" }}>
                        {Object.values(userDetails).map(mapUserDetailsToMovieDetails)}
                    </ListGroup>
                );
            }
        };
        const renderEditButtons = () => {
            if (this.state.user.canEditMovies) {
                return (
                    <Col xs="auto" md="auto">
                        <ButtonGroup xs="auto" md="auto">
                            <Button variant="link" onClick={(e) => this.editMovie(e, movie)}><FaPen color="darkslategray"/></Button>
                            <Button variant="link" onClick={(e) => this.askDeleteMovie(e, movie)}><FaTrash color="red"/></Button>
                        </ButtonGroup>
                    </Col>
                );
            }
        };

        return (
            <ListGroup.Item style={{ overflow: "hidden" }} key={movie.id}>
                <Row style={{alignItems: "center"}}>
                    <Col xs="auto" style={{ paddingLeft: boundsHorPadding, paddingRight: 0 }}>
                        {renderWatchedEye()}
                    </Col>
                    <Col style={{ paddingLeft: horPadding, paddingRight: 0 }}>
                        <Container fluid>
                            <Row className="my-auto text-left" as="h4" style={{color: "darkslategray", cursor: "pointer", fontSize: titleFontSize}}onClick={e => this.toggleMovieDetails(e, movie.id)}>
                                {movie.title}
                            </Row>
                            <Row className="my-auto text-left" as="h6" style={{color: "gray", fontSize: subtitleFontSize}}>
                                {movie.releaseYear}
                            </Row>
                        </Container>
                    </Col>
                    <Col xs="auto" style={{ paddingLeft: horPadding, paddingRight: 0 }}>
                        {renderReviewButton()}
                    </Col>
                    <Col xs="auto" style={{ paddingLeft: horPadding, paddingRight: 0 }}>
                        {renderVoteStars()}
                    </Col>
                    <Col xs="auto" style={{ paddingLeft: horPadding, paddingRight: boundsHorPadding }}>
                        <Container fluid>
                            <Row className="my-auto justify-content-center" as="h4" style={{color: "darkslategray", fontSize: titleFontSize}}>
                                {this.movieAverageVoteString(movie.id)}
                            </Row>
                            <Row className="my-auto justify-content-center" as="h6" style={{color: "gray", fontSize: subtitleFontSize}}>
                                {this.movieUserVoteString(movie.id, this.state.user.id)}
                            </Row>
                        </Container>
                    </Col>
                    {renderEditButtons()}
                </Row>
                {renderMovieDetails()}
            </ListGroup.Item>
        );
    }

    renderMoviesList() {
        if (this.allFilteredMovies === null || this.allFilteredMovies.length === 0) {
            this.allFilteredMovies = this.applyFiltersToMovies();
        }
        return (
            <>
                <ListGroup>
                    {this.allFilteredMovies.map(this.mapMovieToListItem)}
                </ListGroup>
                <Modal show={this.state.showDeleteConfirmationModal} onHide={() => this.setState({ showDeleteConfirmationModal: false })}>
                    <Modal.Header closeButton>
                        <Modal.Title>Delete Movie</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Delete movie '{this.state.deleteConfirmationModalMovieTitle}'?</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ showDeleteConfirmationModal: false })}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={(e) => this.doDeleteMovie(e)}>
                            Delete
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }

    renderFilters() {
        const renderSortButton = () => {
            if (this.state.filtersSortDesc) {
                return (
                    <InputGroup.Append>
                        <Button variant="outline-secondary" onClick={() => { this.allFilteredMovies = null; this.setState({ filtersSortDesc: false }); }}>
                            <FaSortAmountUp/>
                        </Button>
                    </InputGroup.Append>
                );
            }
            else {
                return (
                    <InputGroup.Append>
                        <Button variant="outline-secondary" onClick={() => { this.allFilteredMovies = null; this.setState({ filtersSortDesc: true }); }}>
                            <FaSortAmountDownAlt/>
                        </Button>
                    </InputGroup.Append>
                );
            }
        }
        const renderFilterControls = () => {
            if (this.state.showFilters) {
                return (
                    <Form inline>
                        <InputGroup className="mb-2 mr-sm-2">
                            <InputGroup.Prepend><InputGroup.Text><FaEye/></InputGroup.Text></InputGroup.Prepend>
                            <DropdownButton as={InputGroup.Append} variant="outline-secondary" title={this.state.filtersWatchStatus} style={{ backgroundColor: "white" }}>
                                <Dropdown.Item onSelect={() => { this.allFilteredMovies = null; this.setState({filtersWatchStatus: "All"}); }}>All</Dropdown.Item>
                                <Dropdown.Item onSelect={() => { this.allFilteredMovies = null; this.setState({filtersWatchStatus: "Watched"}); }}>Watched</Dropdown.Item>
                                <Dropdown.Item onSelect={() => { this.allFilteredMovies = null; this.setState({filtersWatchStatus: "Unwatched"}); }}>Unwatched</Dropdown.Item>
                            </DropdownButton>
                        </InputGroup>
                        <InputGroup className="mb-2 mr-sm-2">
                            <InputGroup.Prepend><InputGroup.Text><FaEdit/></InputGroup.Text></InputGroup.Prepend>
                            <DropdownButton as={InputGroup.Append} variant="outline-secondary" title={this.state.filtersUserReviewStatus} style={{ backgroundColor: "white" }}>
                                <Dropdown.Item onSelect={() => { this.allFilteredMovies = null; this.setState({filtersUserReviewStatus: "All"}); }}>All</Dropdown.Item>
                                <Dropdown.Item onSelect={() => { this.allFilteredMovies = null; this.setState({filtersUserReviewStatus: "Reviewed"}); }}>Reviewed</Dropdown.Item>
                                <Dropdown.Item onSelect={() => { this.allFilteredMovies = null; this.setState({filtersUserReviewStatus: "Not Reviewed"}); }}>Not Reviewed</Dropdown.Item>
                            </DropdownButton>
                        </InputGroup>
                        <InputGroup className="mb-2 mr-sm-2">
                            <InputGroup.Prepend><InputGroup.Text><FaStarHalfAlt/></InputGroup.Text></InputGroup.Prepend>
                            <DropdownButton as={InputGroup.Append} variant="outline-secondary" title={this.state.filtersUserVoteStatus} style={{ backgroundColor: "white" }}>
                                <Dropdown.Item onSelect={() => { this.allFilteredMovies = null; this.setState({filtersUserVoteStatus: "All"}); }}>All</Dropdown.Item>
                                <Dropdown.Item onSelect={() => { this.allFilteredMovies = null; this.setState({filtersUserVoteStatus: "Voted"}); }}>Voted</Dropdown.Item>
                                <Dropdown.Item onSelect={() => { this.allFilteredMovies = null; this.setState({filtersUserVoteStatus: "Not Voted"}); }}>Not Voted</Dropdown.Item>
                            </DropdownButton>
                        </InputGroup>
                        <InputGroup className="mb-2 mr-sm-2">
                            <InputGroup.Prepend><InputGroup.Text><FaSortAlphaDown/></InputGroup.Text></InputGroup.Prepend>
                            <DropdownButton as={InputGroup.Append} variant="outline-secondary" title={this.state.filtersSort} style={{ backgroundColor: "white" }}>
                                <Dropdown.Item onSelect={() => { this.allFilteredMovies = null; this.setState({filtersSort: "Movie Title"}); }}>Movie Title</Dropdown.Item>
                                <Dropdown.Item onSelect={() => { this.allFilteredMovies = null; this.setState({filtersSort: "Release Year"}); }}>Release Year</Dropdown.Item>
                                <Dropdown.Item onSelect={() => { this.allFilteredMovies = null; this.setState({filtersSort: "Average Vote"}); }}>Average Vote</Dropdown.Item>
                                <Dropdown.Item onSelect={() => { this.allFilteredMovies = null; this.setState({filtersSort: "My Vote"}); }}>My Vote</Dropdown.Item>
                            </DropdownButton>
                            {renderSortButton()}
                        </InputGroup>
                        <InputGroup className="mb-2 mr-sm-2">
                            <InputGroup.Prepend><InputGroup.Text><FaStar/></InputGroup.Text></InputGroup.Prepend>
                            <DropdownButton as={InputGroup.Append} variant="outline-secondary" title={this.state.filtersShowVote} style={{ backgroundColor: "white" }}>
                                <Dropdown.Item onSelect={() => { this.allFilteredMovies = null; this.setState({filtersShowVote: "Average Vote"}); }}>Average Vote</Dropdown.Item>
                                <Dropdown.Item onSelect={() => { this.allFilteredMovies = null; this.setState({filtersShowVote: "My Vote"}); }}>My Vote</Dropdown.Item>
                            </DropdownButton>
                        </InputGroup>
                    </Form>
                );
                /*<InputGroup className="mb-2 mr-sm-2">
                    <InputGroup.Prepend><InputGroup.Text><FaFileExcel style={{ marginRight: "0.5em" }}/>Export</InputGroup.Text></InputGroup.Prepend>
                    <InputGroup.Append>
                        <Button variant="outline-secondary" href={IntrashBackend.exportExcelUrl()} download><FaDownload/></Button>
                    </InputGroup.Append>
                </InputGroup>*/
            }
        }
        return (
            <>
                <InputGroup className="mb-2 mr-sm-2">
                    <InputGroup.Prepend><InputGroup.Text><FaSearch/></InputGroup.Text></InputGroup.Prepend>
                    <FormControl placeholder="Search" onChange={(e) => { this.allFilteredMovies = null; this.setState({ filtersSearch: e.target.value }); }}/>
                    <InputGroup.Append>
                        <Button variant="outline-secondary" onClick={() => this.setState({ showFilters: !this.state.showFilters })}><FaWrench/></Button>
                    </InputGroup.Append>
                </InputGroup>
                {renderFilterControls()}
            </>
        );
    }

    renderEditMovieModal() {
        return (
            <Modal show={this.state.showEditMovieModal} onHide={() => this.setState({ showEditMovieModal: false })}>
                <Modal.Header closeButton>
                    <Modal.Title>Movie</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Title</Form.Label>
                            <Form.Control type="text" placeholder="Movie Title" value={this.state.editMovieModalTitle} onChange={(e) => this.setState({ editMovieModalTitle: e.target.value })}/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Sort Title</Form.Label>
                            <Form.Control type="text" placeholder="Sort Title" value={this.state.editMovieModalSortTitle} onChange={(e) => this.setState({ editMovieModalSortTitle: e.target.value })}/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Release Year</Form.Label>
                            <Form.Control type="number" id="onlyNumbers" name="onlyNumbers" placeholder="Release Year" value={this.state.editMovieModalReleaseYear} onChange={(e) => this.setState({ editMovieModalReleaseYear: e.target.value })}/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Check label="Watched" checked={this.state.editMovieModalWatched} onChange={(e) => this.toggleEditMovieModalWatched(e)}/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Check label="Clear all votes" checked={this.state.editMovieModalClearAllVotes} onChange={(e) => this.toggleEditMovieModalClearAllVotes(e)}/>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={() => this.setState({ showEditMovieModal: false })}>
                        Cancel
                    </Button>
                    <Button disabled={!this.validateEditMovieModal()} onClick={(e) => this.confirmEditMovie(e)}>
                        OK
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    renderVoteModal() {
        const voteMovieTitle = () => {
            if (this.state.voteModalMovie === null) return "";
            return this.state.voteModalMovie.title;
        };
        return (
            <Modal show={this.state.showVoteModal} onHide={() => this.setState({ showVoteModal: false })}>
                <Modal.Header closeButton>
                    <Modal.Title>{voteMovieTitle()}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Vote</Form.Label>
                            <VoteStars vote={this.state.voteModalVote} onVote={v => this.setState({ voteModalVote: v })}/>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.setState({ showVoteModal: false })}>
                        Cancel
                    </Button>
                    <Button onClick={(e) => this.confirmVote(e)}>
                        OK
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    renderWriteReviewModal() {
        const writeReviewMovieTitle = () => {
            if (this.state.writeReviewModalMovie === null) return "";
            return this.state.writeReviewModalMovie.title;
        };
        return (
            <Modal show={this.state.showWriteReviewModal} onHide={() => this.setState({ showWriteReviewModal: false })}>
                <Modal.Header closeButton>
                    <Modal.Title>{writeReviewMovieTitle()}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Vote</Form.Label>
                            <VoteStars vote={this.state.writeReviewModalVote} onVote={v => this.setState({ writeReviewModalVote: v })}/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Brief</Form.Label>
                            <Form.Control type="text" placeholder="Brief" value={this.state.writeReviewModalBrief} onChange={(e) => this.setState({ writeReviewModalBrief: e.target.value })}/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Review</Form.Label>
                            <Form.Control type="text" as="textarea" placeholder="Review" value={this.state.writeReviewModalReview} onChange={(e) => this.setState({ writeReviewModalReview: e.target.value })}/>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={(e) => this.deleteReview(e)}>
                        Delete Review
                    </Button>
                    <Button variant="secondary" onClick={() => this.setState({ showWriteReviewModal: false })}>
                        Cancel
                    </Button>
                    <Button disabled={!this.validateWriteReviewModal()} onClick={(e) => this.confirmWriteReview(e)}>
                        OK
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    renderReviewModal() {
        return (
            <Modal show={this.state.showReviewModal} onHide={() => this.setState({ showReviewModal: false })}>
                <Modal.Header closeButton>
                    <Container>
                        <Row>
                            <VoteStars canEditVote={false} starSize="1.5em" vote={this.state.reviewModalVote}/>
                        </Row>
                        <Row>
                            <Modal.Title>{this.state.reviewModalBrief}</Modal.Title>
                        </Row>
                    </Container>
                </Modal.Header>
                <Modal.Body style={{ whiteSpace: "pre-line" }}>  
                    {this.state.reviewModalReview}               
                </Modal.Body>
            </Modal>
        );
    }

    applyFiltersToMovies() {
        // Get all the required filters
        var search = this.state.filtersSearch;
        if (search !== null && search.trim() === "") search = null;
        if (search !== null) search = search.toUpperCase();
        const includeWatched = this.state.filtersWatchStatus !== "Unwatched";
        const includeUnwatched = this.state.filtersWatchStatus !== "Watched";
        const includeVoted = this.state.filtersUserVoteStatus !== "Not Voted";
        const includeNotVoted = this.state.filtersUserVoteStatus !== "Voted";
        const includeReviewed = this.state.filtersUserReviewStatus !== "Not Reviewed";
        const includeNotReviewed = this.state.filtersUserReviewStatus !== "Reviewed";

        // Initializations
        var filteredMovies = [];
        const userId = this.state.user === null ? null : this.state.user.id;

        // Filter the movies
        if (this.state.movies) {
            this.state.movies.forEach(m => {
                // Apply the search string (if necessary)
                if (search !== null) {
                    const movieTitle = m.title.toUpperCase();
                    if (!movieTitle.includes(search)) return;
                }

                // Apply the watch status
                if (m.watched && !includeWatched) return;
                if (!m.watched && !includeUnwatched) return;

                // Apply the vote status
                const hasUserVote = this.movieUserVote(m.id, userId) !== null;
                if (hasUserVote && !includeVoted) return;
                if (!hasUserVote && !includeNotVoted) return;
                
                // Apply the review status
                const hasUserReview = this.userHasReviewedMovie(m.id);
                if (hasUserReview && !includeReviewed) return;
                if (!hasUserReview && !includeNotReviewed) return;

                // Add this movie
                filteredMovies.push(m);
            });
        }

        // Sort the movies
        var basicCompareMethod, compareMethod;
        if (this.state.filtersSort === "Average Vote") {
            basicCompareMethod = (a, b) => {
                const aVote = this.movieAverageVote(a.id);
                const bVote = this.movieAverageVote(b.id);
                if (aVote === null) return -1;
                if (bVote === null) return 1;
                return aVote - bVote;
            };
        }
        else if (this.state.filtersSort === "My Vote") {
            basicCompareMethod = (a, b) => {
                const aVote = this.movieUserVote(a.id, userId);
                const bVote = this.movieUserVote(b.id, userId);
                if (aVote === null) return -1;
                if (bVote === null) return 1;
                return aVote - bVote;
            };
        }
        else if (this.state.filtersSort === "Release Year") {
            basicCompareMethod = (a, b) => { return a.releaseYear - b.releaseYear };
        }
        else {
            basicCompareMethod = (a, b) => { 
                var aTitle;
                if (a.sortTitle != null && a.sortTitle.trim() !== "") { aTitle = a.sortTitle; }
                else { aTitle = a.title; }
                var bTitle;
                if (b.sortTitle != null && b.sortTitle.trim() !== "") { bTitle = b.sortTitle; }
                else { bTitle = b.title; }
                return aTitle.toUpperCase() < bTitle.toUpperCase() ? -1 : 1
            };
        }
        if (this.state.filtersSortDesc) {
            compareMethod = (a, b) => { return -basicCompareMethod(a, b); }
        }
        else {
            compareMethod = basicCompareMethod;
        }
        filteredMovies.sort(compareMethod);

        // Return the filtered movies
        return filteredMovies;
    }

    render() {
        const renderAddMovieButton = () => {
            if (this.state.user && this.state.user.canEditMovies) {
                return (
                    <>
                        <br/>
                        <Row><Col><Button variant="outline-primary" block onClick={(e) => this.startAddMovie(e)}><FaPlus/></Button></Col></Row>
                    </>
                )
            }
        }
        return (
            <>
                <Container fluid>
                    <Row><Col><h3 className="text-center">All Movies</h3></Col></Row>
                    <br/>
                    {this.renderFilters()}
                    {renderAddMovieButton()}
                    <br/>
                    {this.renderMoviesList()}
                </Container>
                {this.renderEditMovieModal()}
                {this.renderVoteModal()}
                {this.renderWriteReviewModal()}
                {this.renderReviewModal()}
                <Modal show={this.state.showErrorModal} onHide={() => this.setState({ showErrorModal: false })}>
                    <Modal.Header closeButton>
                        <Modal.Title>Error</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{this.state.errorModalText}</Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => this.setState({ showErrorModal: false })}>
                            OK
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}